module.exports = __webpack_public_path__ + "img/fonctionnalites-avancees-integration-fluide.82ef7571.webp";